module.exports = __webpack_public_path__ + "img/tarjeta_beneficios_cesur.e2dd2534.jpg";